
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wydanie/[slug]",
      function () {
        return require("private-next-pages/wydanie/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wydanie/[slug]"])
      });
    }
  